import { FONT_PRIMARY } from "@/theme/typography";

export const accordionStyles = {
  "& .MuiAccordionDetails-root > div": {
    pb: { xs: 1.5, md: 1.25 },
    pt: { md: 4 },
  },
  "& .MuiAccordionSummary-content": {
    // fontSize: { xs: "1.125rem !important", md: "1.25rem !important" },

    svg: {
      width: { xs: 24, md: 32 },
      height: { xs: 24, md: 32 },
      mr: 2
    }
  },

  "& .MuiAccordionSummary-content .MuiTypography-root": {
    fontSize: { xs: "1.125rem", md: "1.25rem" },
    fontFamily: FONT_PRIMARY
  }

};

export const listStyles = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "1fr 1fr",
    md: "1fr",
    lg: "1fr 1fr",
  },
  gap: { xs: 1, md: 2, lg: 3 },
  listStyleType: "disc",
  pl: 2,
  mb: { xs: 2.5 },
};

export const listItemStyles = {
  display: "list-item",
  "&::marker": { color: "text.primary" },
};
